/**
 * Breadcrumb Navigation Component
 * Sleek inline breadcrumb designed for gradient headers
 */

import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  currentPage: string;
}

export default function Breadcrumb({ items, currentPage }: BreadcrumbProps) {
  return (
    <div className="flex items-center gap-2 text-white/70 text-xs mb-0.5">
      {items.map((item, index) => (
        <span key={index} className="flex items-center gap-2">
          {item.path ? (
            <Link
              to={item.path}
              className="hover:text-white transition-colors"
            >
              {item.label}
            </Link>
          ) : (
            <span>{item.label}</span>
          )}
          <i className="ri-arrow-right-s-line text-sm"></i>
        </span>
      ))}
      <span className="text-white font-medium">{currentPage}</span>
    </div>
  );
}
